import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TimelineComponent} from './components/timeline/timeline.component';
import {VolumeComponent} from './components/volume/volume.component';
import {BarComponent} from './components/bar/bar.component';
import {PlayPauseComponent} from './components/play-pause/play-pause.component';
import {MatSliderModule} from '@angular/material/slider';
import {TimerComponent} from './components/timer/timer.component';
import {FullScreenComponent} from './components/full-screen/full-screen.component';
import {ResolutionComponent} from './components/resolution/resolution.component';
import {MatMenuModule} from '@angular/material/menu';
import {SharedModule} from '../shared/shared.module';

@NgModule({
    declarations: [
        TimelineComponent,
        VolumeComponent,
        BarComponent,
        PlayPauseComponent,
        TimerComponent,
        FullScreenComponent,
        ResolutionComponent
    ],
    exports: [
        TimelineComponent,
        ResolutionComponent
    ],
    imports: [
        CommonModule,
        MatSliderModule,
        MatMenuModule,
        SharedModule
    ]
})
export class TimelineModule { }
